import type { CategoryTree } from '~~/types/category/CategoryTree';

export const getCategoryPath = (slug: string, categoryTree: CategoryTree) => {

  return categoryTree.prefix ? `${categoryTree.prefix}/${slug}` : slug;

};
